import type { PlatformRole } from '@/graphql/staff';
import { ROLES } from '@/lib/staff';

import styles from './RolePicker.module.css';

export interface RolePickerProps {
  value: readonly PlatformRole[];
  onChange: (roles: PlatformRole[]) => void;
  disabled?: boolean;
}

/** Every platform role as a card to tick, each saying what it lets someone do. */
export function RolePicker({ value, onChange, disabled = false }: RolePickerProps) {
  const toggle = (role: PlatformRole) =>
    onChange(
      value.includes(role)
        ? value.filter((held) => held !== role)
        : ROLES.map((entry) => entry.role).filter((r) => r === role || value.includes(r)),
    );

  return (
    <fieldset className={styles.fieldset} disabled={disabled}>
      <legend className={styles.legend}>Roles</legend>
      {ROLES.map(({ role, name, summary }) => {
        const checked = value.includes(role);
        return (
          <label className={`${styles.option} ${checked ? styles.checked : ''}`} key={role}>
            <input
              checked={checked}
              className={styles.input}
              onChange={() => toggle(role)}
              type="checkbox"
            />
            <span className={styles.text}>
              <span className={styles.name}>{name}</span>
              <span className={styles.summary}>{summary}</span>
            </span>
          </label>
        );
      })}
    </fieldset>
  );
}
